import React from "react";
import { Link } from "react-router-dom";

const fallbackCategories = ["Development", "Design", "Marketing", "Customer Support", "Human Resource"];

const jobTypes = ["Full Time", "Part Time", "Contract", "Remote", "Internship", "Temporary"];

const dateFilters = [
  { id: "", label: "Anytime" },
  { id: "last-24-hours", label: "Last 24 Hours" },
  { id: "last-7-days", label: "Last 7 Days" },
  { id: "last-30-days", label: "Last 30 Days" },
];

const FiltersSidebar = ({ filters, filterOptions = {}, onChange, onJobTypeChange, onSubmit, onReset }) => {
  const categories = filterOptions.categories?.length ? filterOptions.categories : fallbackCategories;
  const locations = filterOptions.locations ?? [];
  const experiences = filterOptions.experiences ?? [];

  return (
    <div className="inner-column">
      <div className="filters-outer">
        <button type="button" className="theme-btn close-filters">X</button>

        <form onSubmit={onSubmit}>
          <div className="filter-block">
            <h4>Search</h4>
            <div className="form-group">
              <input type="text" name="keyword" placeholder="Job title, keyword, or company" value={filters.keyword} onChange={onChange} />
              <span className="icon flaticon-search-3"></span>
            </div>
          </div>

          <div className="filter-block">
            <h4>Location</h4>
            <div className="form-group">
              <input type="text" name="location" list="job-location-options" placeholder="City, country, or remote" value={filters.location} onChange={onChange} />
              <datalist id="job-location-options">
                {locations.map((location) => (
                  <option value={location} key={location} />
                ))}
              </datalist>
              <span className="icon flaticon-map-locator"></span>
            </div>
          </div>

          <div className="filter-block">
            <h4>Category</h4>
            <div className="form-group">
              <select className="chosen-select" name="category" value={filters.category} onChange={onChange}>
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option value={category} key={category}>{category}</option>
                ))}
              </select>
              <span className="icon flaticon-briefcase"></span>
            </div>
          </div>

          <div className="filter-block">
            <h4>Experience</h4>
            <div className="form-group">
              <select className="chosen-select" name="experience" value={filters.experience} onChange={onChange}>
                <option value="">Any Experience</option>
                {experiences.map((experience) => (
                  <option value={experience} key={experience}>{experience}</option>
                ))}
              </select>
              <span className="icon flaticon-user"></span>
            </div>
          </div>

          <div className="filter-block">
            <h4>Salary Range</h4>
            <div className="row">
              <div className="form-group col-6">
                <input type="number" min="0" name="salaryMin" placeholder="Min" value={filters.salaryMin} onChange={onChange} />
              </div>
              <div className="form-group col-6">
                <input type="number" min="0" name="salaryMax" placeholder="Max" value={filters.salaryMax} onChange={onChange} />
              </div>
            </div>
          </div>

          <div className="switchbox-outer">
            <h4>Job Type</h4>
            <ul className="switchbox">
              {jobTypes.map((type) => (
                <li key={type}>
                  <label className="switch">
                    <input type="checkbox" checked={filters.jobTypes.includes(type)} onChange={(e) => onJobTypeChange(type, e.target.checked)} />
                    <span className="slider round"></span>
                    <span className="title">{type}</span>
                  </label>
                </li>
              ))}
            </ul>
          </div>

          <div className="checkbox-outer">
            <h4>Date Posted</h4>
            <ul className="checkboxes date-filter-radios">
              {dateFilters.map((filter) => (
                <li key={filter.id || "anytime"}>
                  <input id={`date-${filter.id || "anytime"}`} type="radio" name="date_posted" value={filter.id} checked={filters.datePosted === filter.id} onChange={onChange} />
                  <label htmlFor={`date-${filter.id || "anytime"}`}>{filter.label}</label>
                </li>
              ))}
            </ul>
          </div>

          <div className="form-group">
            <button type="submit" className="theme-btn btn-style-one w-100">Apply Filters</button>
            <button type="button" className="theme-btn btn-style-three w-100 mt-2" onClick={onReset}>Reset</button>
          </div>
        </form>
      </div>

      <div className="call-to-action-four">
        <h5>Recruiting?</h5>
        <p>Choose pay-per-post or a 12-post pack to publish jobs and review applicants.</p>
        <Link to="/pricing" className="theme-btn btn-style-one bg-blue"><span className="btn-title">View Pricing</span></Link>
        <div className="image" style={{ backgroundImage: "url(images/resource/ads-bg-4.png)" }}></div>
      </div>
    </div>
  );
};

export default FiltersSidebar;
